export const SidebarIdPlanSettings = 'PLAN_SETTINGS' as const;
